import React, {useEffect} from "react"
import Header from "../header/header"
import Footer from "../footer/footer";
import {Helmet} from "react-helmet";
import Progress from "../kit/Progress"
import CookieConsent from "react-cookie-consent";

const Layout = (props) => {

    
    const target = React.createRef();
  
    return (
        <div>
                <Progress target={target}/>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{props.title || ""}</title>
            </Helmet>
            <Header />
                <div ref={target}>
                    {props.children}
                </div>
            <CookieConsent
                location="bottom"
                buttonText="Accept"
                declineButtonText="Decline"
                cookieName="gatsby-gdpr-google-analytics">
                <div class="modal-body">
                    <h5 class="modal-title" id="exampleModalLabel">
                        Nous respectons votre vie privée
                    </h5>
                    <div class="flash-news text-center">
                        <p>
                            Bienvenue chez Maroc Leasing ! Nous utilisons des cookies,
                            y compris des cookies tiers, passurer le bon fonctionnement
                            du site, mesurer notre audience, optimiser les performances
                            du site pour vous proposer des offres adaptées selon vos
                            centre d’intérêt. Pour plus d’informations, vous pouvez
                            consulter notre{' '}
                            <a href="https://www.marocleasing.ma/cgu">politique de confidentialité.</a>
                        </p>
                    </div>
                </div>
            </CookieConsent>
            <Footer />
        </div>
    );
}
export default React.memo(Layout);